import { pList, rIstatistikSonuc_2, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError, IKeyValPair } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_api_set_input = (body: pList | null | undefined): IInputAction<pList> =>
  ActionFunctions.action_api_set_input(
    ActionSubTypes.API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR,
    true,
    body
  );

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR,
    new Api.Bilgi.OyakKiraTrGeneliKirayaVerilenTasinmazlar().Request(body),
    false,
    true,
    body
  );

export const action_async_complete = (
  data: rValue<rIstatistikSonuc_2> | null | undefined,
  error: IError | null | undefined
): IApiAction<Collection<IKeyValPair>> =>
  ActionFunctions.action_async_complete_api<Collection<IKeyValPair>>(
    ActionSubTypes.API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR,
    new Collection(((data?.Value?.SonucListesi as unknown) as IKeyValPair[]) || []),
    error
  );
